import axios from "axios";
import "./MyItem.css";
import { signOut } from "firebase/auth";
import React, { useEffect, useState } from "react";
import { Table } from "react-bootstrap";
import { confirm } from "react-bootstrap-confirmation";
import { useAuthState } from "react-firebase-hooks/auth";
import { useNavigate } from "react-router-dom";
import auth from "../../firebase.init";

const MyItem = () => {
  const [user, loading, error] = useAuthState(auth);
  const [myProducts, setMyProducts] = useState([]);

  const navigate = useNavigate();

  useEffect(() => {
    const getMyProducts = async () => {
      const email = user.email;
      const url = `https://nameless-earth-37809.herokuapp.com/myProducts?email=${email}`;
      try {
        const { data } = await axios.get(url, {
          headers: {
            authorization: `Bearer ${localStorage.getItem("accessToken")}`,
          },
        });
        setMyProducts(data);
      } catch (error) {
        console.log(error.message);
        if (error.response.status === 403 || error.response.status === 401) {
          navigate("/login");
          signOut(auth);
        }
      }
    };
    getMyProducts();
  }, [user]);

  const handleRemoveItem = async (productId) => {
    const result = await confirm("Are you really sure?");
    if (result) {
      const url = `https://nameless-earth-37809.herokuapp.com/product/${productId}`;
      fetch(url, {
        method: "DELETE",
      })
        .then((res) => res.json())
        .then((data) => {
          const productsLeft = myProducts.filter(
            (product) => product._id !== productId
          );
          setMyProducts(productsLeft);
        });
    }
  };

  return (
    <div className="mt-5 myItem-container d-flex justify-content-center flex-column align-items-center ">
      <h5>
        Logged As: <em>{user.email}</em>
      </h5>
      <Table
        striped
        bordered
        hover
        className="table-sm container table-responsive "
      >
        <thead>
          <tr>
            {/* <th>ID</th> */}
            <th>Product Name</th>
            <th>Quantity</th>
            <th>Price</th>
            <th>Supplier</th>
            <th>Remove</th>
          </tr>
        </thead>
        <tbody>
          {myProducts.map((p) => {
            return (
              <tr key={p._id}>
                {/* <td>{p._id}</td> */}
                <td>
                  {" "}
                  <small>{p.name}</small>{" "}
                </td>
                <td>{p.quantity}</td>
                <td>{p.price}</td>
                <td>{p.supplier}</td>
                <td>
                  {" "}
                  <button
                    onClick={() => handleRemoveItem(p._id)}
                    className="btn btn-danger"
                  >
                    Delete
                  </button>{" "}
                </td>
              </tr>
            );
          })}
        </tbody>
      </Table>
    </div>
  );
};

export default MyItem;
